"use strict";
angular.module("televisionToBeCompiledRouterModule", [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.television.waitcompiled', {
            url: '/waitcompiled?siteid',
            views: {
                "main@front.editctr": {
                    templateUrl: "./editingCenter/television/toBeCompiled/main_tpl.html",
                    controller: "televisionToBeCompiledCtrl"
                }
            }
        }).state('televisionmanuscript', {
            url: "/televisionmanuscript?tvchannelid&tvchnldocid&tvmetadataid&tvsiteid&tvplatform",
            views: {
                '': {
                    templateUrl: './editingCenter/television/toBeCompiled/manuscript/manuscript_tpl.html',
                    controller: "tvManuscriptCtrl"
                }
            }
        }).state('televisionplannedorder', {
            url: "/televisionplannedorder?tvchannelid&tvchnldocid&tvmetadataid&tvsiteid&tvplatform",
            views: {
                '': {
                    templateUrl: './editingCenter/television/toBeCompiled/plannedOrder/plannedOrder_tpl.html',
                    controller: "tvPlannedOrderCtrl"
                }
            }
        });
    }])